import { IInternalAccount } from "@wingspanhq/bookkeeping/dist/lib/interfaces";
import {
  IInstantPayoutResponse,
  IPayoutSettingsResponse,
  PayoutPreferences
} from "@wingspanhq/payments/dist/interfaces";
import { IAccount } from "@wingspanhq/users/dist/lib/interfaces";
import { getAccountName } from "../../components/WSAccountsListV2/utils";
import { getWalletAccountName } from "../../query/payments/selectors";
import { getPayoutAccount } from "../../query/users/selectors";
import { getInstantPayoutCardName } from "../../types/creditCard";

export const getPayoutSettingsCalculations = ({
  payoutSettings,
  accounts,
  instantPayoutAccount,
  bankingAccount
}: {
  payoutSettings: IPayoutSettingsResponse;
  accounts?: IAccount[];
  instantPayoutAccount?: IInstantPayoutResponse;
  bankingAccount?: IInternalAccount;
}) => {
  const standardDestination = payoutSettings.payoutDestinations.find(
    d => d.payoutMethod === PayoutPreferences.Standard
  );
  const standardAccountPercentage = standardDestination?.percentage || 0;
  const standardWalletPercentage = 100 - standardAccountPercentage;

  const instantDestination = payoutSettings.payoutDestinations.find(
    d => d.payoutMethod === PayoutPreferences.Instant
  );
  const instantAccountPercentage = instantDestination?.percentage || 0;
  const instantWalletPercentage = 100 - instantAccountPercentage;

  const standardPayoutAccount = getPayoutAccount(
    payoutSettings,
    accounts || []
  );
  const standardPayoutAccountName = standardPayoutAccount
    ? getAccountName(standardPayoutAccount)
    : undefined;

  const instantPayoutAccountName = instantPayoutAccount
    ? getInstantPayoutCardName(instantPayoutAccount)
    : "Debit card";

  const walletAccountName = getWalletAccountName(bankingAccount);

  return {
    isPayoutMethodInstant:
      payoutSettings.payoutPreferences === PayoutPreferences.Instant,
    isPayoutMethodStandard:
      payoutSettings.payoutPreferences === PayoutPreferences.Standard,
    payoutPercentage: {
      standard: {
        account: standardAccountPercentage,
        wallet: standardWalletPercentage
      },
      instant: {
        account: instantAccountPercentage,
        wallet: instantWalletPercentage
      }
    },

    standardPayoutAccount,
    standardPayoutAccountName,

    instantPayoutAccount,
    instantPayoutAccountName,

    bankingAccount,
    walletAccountName
  };
};
